import React from "react";

const IconPrinter1 = ({ color = "#e31c19" }) => {
  return (
    <svg
      id="UI_icon_printer_light"
      data-name="UI icon/printer/light"
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 38 38"
    >
      <path
        id="Union"
        d="M22.8,38H15.2a5.706,5.706,0,0,1-5.7-5.7H5.7A5.706,5.706,0,0,1,0,26.6V15.2A5.706,5.706,0,0,1,5.7,9.5H9.5V5.7A5.706,5.706,0,0,1,15.2,0h7.6a5.707,5.707,0,0,1,5.7,5.7V9.5h3.8A5.706,5.706,0,0,1,38,15.2V26.6a5.706,5.706,0,0,1-5.7,5.7H28.5A5.708,5.708,0,0,1,22.8,38ZM13.3,26.6v5.7a1.9,1.9,0,0,0,1.9,1.9h7.6a1.9,1.9,0,0,0,1.9-1.9V26.6ZM9.5,22.8h19a1.9,1.9,0,0,1,0,3.8v1.9h3.8a1.9,1.9,0,0,0,1.9-1.9V15.2a1.9,1.9,0,0,0-1.9-1.9H5.7a1.9,1.9,0,0,0-1.9,1.9V26.6a1.9,1.9,0,0,0,1.9,1.9H9.5V26.6a1.9,1.9,0,1,1,0-3.8Zm5.7-19a1.9,1.9,0,0,0-1.9,1.9V9.5H24.7V5.7a1.9,1.9,0,0,0-1.9-1.9Z"
        fill={color}
      />
      <path
        id="Ellipse_16_Stroke_"
        data-name="Ellipse 16 (Stroke)"
        d="M1.917,3.833A1.917,1.917,0,1,0,0,1.917,1.917,1.917,0,0,0,1.917,3.833Z"
        transform="translate(28.583 15.167)"
        fill={color}
      />
    </svg>
  );
};

export default IconPrinter1;
